import { Skeleton } from "antd"

import styles from "./QuickWinsList.module.scss"

export const CardSkeleton = () => (
  <div className={styles.skeletonCard}>
    <Skeleton
      active
      title={{ width: "60%" }}
      paragraph={{ rows: 3, width: ["40%", "80%", "30%"] }}
    />
  </div>
)
